// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-salary {
    color: #111c33;
}

.employee-salary__topbar {
    margin-bottom: 24px;
}

.employee-salary__topbar-left,
.employee-salary__topbar-right {
    margin-bottom: 10px;
}

.employee-salary__topbar-right .btn {
    margin-left: 8px;
}

.employee-salary__panel {
    margin-bottom: 0;
    border-radius: 12px;
    border-color: #e6eaf0;
    box-shadow: none;
}

.employee-salary__heading {
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 24px;
    color: #111c33;
}

.employee-salary__pager-wrap {
    margin: 40px 0 60px;
}

.employee-salary__pager-label {
    min-width: 220px;
    pointer-events: none;
    cursor: default;
    text-transform: capitalize;
}

.fc-wrap {
    position: relative;
}

.fc-floating-btn {
    position: fixed;
    right: max(120px, calc((100vw - 1170px) / 2 - 100px));
    bottom: 50px;
    z-index: 10;
}

/* modal */

.salary-popup-modal .modal-dialog {
    width: 760px;
}

.salary-popup-modal .modal-content {
    border: none;
    border-radius: 16px;
    box-shadow: 0 16px 40px rgba(17, 28, 51, 0.14);
}

.salary-popup {
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
}

.salary-popup__header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-bottom: none;
    padding: 0 24px 8px;
}

.salary-popup__title {
    margin: 0;
    text-align: left;
    font-size: 28px;
    line-height: 1.15;
    color: #111c33;
}

.salary-popup__close {
    float: none;
    margin: 0 0 0 auto;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    line-height: 1;
    opacity: 1;
    color: #111c33;
}

.salary-popup__close:hover,
.salary-popup__close:focus {
    opacity: 0.75;
}

.salary-popup__body {
    padding: 8px 24px 16px;
}

.salary-popup__pager-wrap {
    margin-bottom: 24px;
}

.salary-popup__date-label {
    min-width: 220px;
    pointer-events: none;
    cursor: default;
}

.salary-popup__section-title {
    margin: 0 0 18px;
    color: #9aa1ad;
    font-size: 17px;
    font-weight: 500;
    text-align: left;
}

.salary-popup__rows {
    margin-bottom: 12px;
}

.salary-popup__row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.salary-popup__row:last-child {
    margin-bottom: 0;
}

.salary-popup__row-label {
    width: 110px;
    min-width: 110px;
    margin: 0;
    padding: 0;
    text-align: left;
    font-size: 17px;
    color: #111c33;
}

.salary-popup__row-control {
    flex: 1 1 auto;
    min-width: 0;
}

.salary-popup__input-group {
    width: 100%;
}

.salary-popup__input-group .form-control {
    z-index: 1;
}

.salary-popup__input {
    height: 42px;
    font-size: 16px;
    border-color: #dfe5ec;
    box-shadow: none;
    padding: 6px 12px;
    text-align: left;
}

.salary-popup__input:focus {
    border-color: #ea8b74;
    box-shadow: none;
}

.salary-popup__trash {
    height: 42px;
    min-width: 42px;
    border-color: #dfe5ec;
    padding: 6px 12px;
    font-size: 14px;
}

.salary-popup__trash:hover,
.salary-popup__trash:focus {
    background: #f8f9fb;
    border-color: #d0d7e2;
}

.salary-popup__checkbox {
    margin: 20px 0 0;
    padding-left: 0;
    font-size: 15px;
    color: #7f8897;
}

.salary-popup__checkbox label {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    padding-left: 0;
    font-weight: 500;
}

.salary-popup__checkbox input[type="checkbox"] {
    margin: 0;
    position: relative;
    top: 0;
    transform: scale(0.95);
}

.salary-popup__footer {
    border-top: none;
    padding: 0 24px 24px;
}

.salary-popup__btn {
    min-width: 140px;
    height: 42px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 700;
    padding: 8px 18px;
}

.salary-popup__btn + .salary-popup__btn {
    margin-left: 8px;
}

.salary-popup__btn--cancel {
    border-width: 2px;
}

.salary-popup__btn--save {
    background-color: #ea8b74;
    border-color: #ea8b74;
}

.salary-popup__btn--save:hover,
.salary-popup__btn--save:focus {
    background-color: #df7d65;
    border-color: #df7d65;
}

.salary-popup__btn--save[disabled],
.salary-popup__btn--save:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* calendar */

.employee-salary-calendar {
    --fc-small-font-size: .95em;
}

.fc-col-header-cell a,
.fc-daygrid-day-number {
    color: #000;
}

.fc-col-header-cell.fc-day.fc-day-sat a,
.fc-col-header-cell.fc-day.fc-day-sun a {
    color: #E78774;
}

.fc-col-header-cell.fc-day.fc-day-sat a:hover,
.fc-col-header-cell.fc-day.fc-day-sun a:hover {
    color: #E78774;
    text-decoration: underline;
}

.fc-theme-standard .fc-scrollgrid {
    border: 0;
}

.fc-daygrid-day-events {
    pointer-events: none;
}

.fc-scrollgrid {
    border: none;
}

.fc-scrollgrid th,
.fc-scrollgrid td {
    border-color: transparent;
}

.fc-scrollgrid-section-header {
    color: #000;
    font-size: 16px;
    font-weight: 400;
}

.fc-scrollgrid-section-header .fc-scroller-harness,
.fc-scrollgrid-section-header .fc-scroller {
    overflow: visible !important;
}

.fc-scrollgrid-section-header .fc-col-header {
    background: #F9F8F6;
    margin: -10px 0 10px 0 !important;
}

.fc-scrollgrid-section-header .fc-col-header-cell {
    height: 46px;
    vertical-align: middle;
}

.fc-scrollgrid-section-header .fc-col-header-cell-cushion {
    color: inherit;
    font-weight: normal;
}

.fc-daygrid-body .fc-daygrid-day-frame {
    background-color: #F9F8F6;
}

.fc-daygrid-body tr:first-child .fc-daygrid-day-frame {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.fc-daygrid-body tr:last-child .fc-daygrid-day-frame {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}

.fc-daygrid-body .fc-daygrid-day-top {
    flex-direction: row;
    justify-content: center;
    padding-top: 8px;
    padding-bottom: 8px;
}

.fc.daygrid-body .fc-daygrid-day-top .fc-daygrid-day-number,
.fc-daygrid-body .fc-daygrid-day-top .fc-daygrid-day-number {
    font-size: inherit;
    min-width: 27px;
    text-align: center;
    border-radius: 1000px;
}

.fc-daygrid-body .fc-day.fc-day-today {
    background-color: transparent;
}

.fc-daygrid-body .fc-day.fc-day-today .fc-daygrid-day-number {
    background-color: #E78774;
    color: #fff;
}

.fc-daygrid-more-link {
    font-size: 10px;
    color: inherit;
    opacity: 0.4;
    text-transform: lowercase;
    padding: 4px 0;
    display: inline-block;
}

/* salary events */

.salary-calendar-event {
    background: #7ce1b9 !important;
    /*border: 1px solid #4fbf93 !important;*/
    border:none;
    border-radius: 8px !important;
    margin-top: 4px !important;
    padding: 0 !important;
}

.salary-calendar-event .fc-event-main {
    padding: 0 !important;
}

.salary-calendar-event__inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    width: 100%;
    min-height: 28px;
    padding: 4px 8px;
    box-sizing: border-box;
    font-size: 12px;
    line-height: 1.2;
    color: #fff;
}

.salary-calendar-event__title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.salary-calendar-event__amount {
    flex-shrink: 0;
    white-space: nowrap;
    color: #fff;
}

@media (max-width: 991px) {
    .employee-salary__topbar-right {
        text-align: left;
    }

    .employee-salary__topbar-right .btn {
        margin-left: 0;
        margin-right: 8px;
        margin-bottom: 8px;
    }

    .salary-popup-modal .modal-dialog {
        width: auto;
        margin: 15px;
    }
}

@media (max-width: 767px) {
    .employee-salary__pager-label,
    .salary-popup__date-label {
        min-width: 180px;
    }

    .salary-popup__title {
        font-size: 18px;
    }

    .salary-popup__header {
        padding: 0 20px 10px;
    }

    .salary-popup__body {
        padding: 10px 20px 20px;
    }

    .salary-popup__row {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
    }

    .salary-popup__row-label {
        width: auto;
        min-width: 0;
    }

    .salary-popup__footer {
        padding: 0 20px 20px;
        text-align: left;
    }

    .salary-popup__btn {
        min-width: 0;
        width: 100%;
        margin: 0 0 10px 0;
    }

    .salary-popup__btn + .salary-popup__btn {
        margin-left: 0;
    }

    .fc-floating-btn {
        position: static;
        margin-top: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/legacy/lib/fullCalendar/style.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,qDAAqD;IACrD,YAAY;IACZ,WAAW;AACf;;AAEA,UAAU;;AAEV;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,UAAU;IACV,cAAc;AAClB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,MAAM;IACN,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,aAAa;;AAEb;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA,kBAAkB;;AAElB;IACI,8BAA8B;IAC9B,wCAAwC;IACxC,WAAW;IACX,6BAA6B;IAC7B,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;;QAEI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ","sourcesContent":[".employee-salary {\n    color: #111c33;\n}\n\n.employee-salary__topbar {\n    margin-bottom: 24px;\n}\n\n.employee-salary__topbar-left,\n.employee-salary__topbar-right {\n    margin-bottom: 10px;\n}\n\n.employee-salary__topbar-right .btn {\n    margin-left: 8px;\n}\n\n.employee-salary__panel {\n    margin-bottom: 0;\n    border-radius: 12px;\n    border-color: #e6eaf0;\n    box-shadow: none;\n}\n\n.employee-salary__heading {\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 24px;\n    color: #111c33;\n}\n\n.employee-salary__pager-wrap {\n    margin: 40px 0 60px;\n}\n\n.employee-salary__pager-label {\n    min-width: 220px;\n    pointer-events: none;\n    cursor: default;\n    text-transform: capitalize;\n}\n\n.fc-wrap {\n    position: relative;\n}\n\n.fc-floating-btn {\n    position: fixed;\n    right: max(120px, calc((100vw - 1170px) / 2 - 100px));\n    bottom: 50px;\n    z-index: 10;\n}\n\n/* modal */\n\n.salary-popup-modal .modal-dialog {\n    width: 760px;\n}\n\n.salary-popup-modal .modal-content {\n    border: none;\n    border-radius: 16px;\n    box-shadow: 0 16px 40px rgba(17, 28, 51, 0.14);\n}\n\n.salary-popup {\n    background: #fff;\n    border-radius: 16px;\n    overflow: hidden;\n}\n\n.salary-popup__header {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    border-bottom: none;\n    padding: 0 24px 8px;\n}\n\n.salary-popup__title {\n    margin: 0;\n    text-align: left;\n    font-size: 28px;\n    line-height: 1.15;\n    color: #111c33;\n}\n\n.salary-popup__close {\n    float: none;\n    margin: 0 0 0 auto;\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 28px;\n    line-height: 1;\n    opacity: 1;\n    color: #111c33;\n}\n\n.salary-popup__close:hover,\n.salary-popup__close:focus {\n    opacity: 0.75;\n}\n\n.salary-popup__body {\n    padding: 8px 24px 16px;\n}\n\n.salary-popup__pager-wrap {\n    margin-bottom: 24px;\n}\n\n.salary-popup__date-label {\n    min-width: 220px;\n    pointer-events: none;\n    cursor: default;\n}\n\n.salary-popup__section-title {\n    margin: 0 0 18px;\n    color: #9aa1ad;\n    font-size: 17px;\n    font-weight: 500;\n    text-align: left;\n}\n\n.salary-popup__rows {\n    margin-bottom: 12px;\n}\n\n.salary-popup__row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.salary-popup__row:last-child {\n    margin-bottom: 0;\n}\n\n.salary-popup__row-label {\n    width: 110px;\n    min-width: 110px;\n    margin: 0;\n    padding: 0;\n    text-align: left;\n    font-size: 17px;\n    color: #111c33;\n}\n\n.salary-popup__row-control {\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.salary-popup__input-group {\n    width: 100%;\n}\n\n.salary-popup__input-group .form-control {\n    z-index: 1;\n}\n\n.salary-popup__input {\n    height: 42px;\n    font-size: 16px;\n    border-color: #dfe5ec;\n    box-shadow: none;\n    padding: 6px 12px;\n    text-align: left;\n}\n\n.salary-popup__input:focus {\n    border-color: #ea8b74;\n    box-shadow: none;\n}\n\n.salary-popup__trash {\n    height: 42px;\n    min-width: 42px;\n    border-color: #dfe5ec;\n    padding: 6px 12px;\n    font-size: 14px;\n}\n\n.salary-popup__trash:hover,\n.salary-popup__trash:focus {\n    background: #f8f9fb;\n    border-color: #d0d7e2;\n}\n\n.salary-popup__checkbox {\n    margin: 20px 0 0;\n    padding-left: 0;\n    font-size: 15px;\n    color: #7f8897;\n}\n\n.salary-popup__checkbox label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0;\n    padding-left: 0;\n    font-weight: 500;\n}\n\n.salary-popup__checkbox input[type=\"checkbox\"] {\n    margin: 0;\n    position: relative;\n    top: 0;\n    transform: scale(0.95);\n}\n\n.salary-popup__footer {\n    border-top: none;\n    padding: 0 24px 24px;\n}\n\n.salary-popup__btn {\n    min-width: 140px;\n    height: 42px;\n    border-radius: 10px;\n    font-size: 15px;\n    font-weight: 700;\n    padding: 8px 18px;\n}\n\n.salary-popup__btn + .salary-popup__btn {\n    margin-left: 8px;\n}\n\n.salary-popup__btn--cancel {\n    border-width: 2px;\n}\n\n.salary-popup__btn--save {\n    background-color: #ea8b74;\n    border-color: #ea8b74;\n}\n\n.salary-popup__btn--save:hover,\n.salary-popup__btn--save:focus {\n    background-color: #df7d65;\n    border-color: #df7d65;\n}\n\n.salary-popup__btn--save[disabled],\n.salary-popup__btn--save:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* calendar */\n\n.employee-salary-calendar {\n    --fc-small-font-size: .95em;\n}\n\n.fc-col-header-cell a,\n.fc-daygrid-day-number {\n    color: #000;\n}\n\n.fc-col-header-cell.fc-day.fc-day-sat a,\n.fc-col-header-cell.fc-day.fc-day-sun a {\n    color: #E78774;\n}\n\n.fc-col-header-cell.fc-day.fc-day-sat a:hover,\n.fc-col-header-cell.fc-day.fc-day-sun a:hover {\n    color: #E78774;\n    text-decoration: underline;\n}\n\n.fc-theme-standard .fc-scrollgrid {\n    border: 0;\n}\n\n.fc-daygrid-day-events {\n    pointer-events: none;\n}\n\n.fc-scrollgrid {\n    border: none;\n}\n\n.fc-scrollgrid th,\n.fc-scrollgrid td {\n    border-color: transparent;\n}\n\n.fc-scrollgrid-section-header {\n    color: #000;\n    font-size: 16px;\n    font-weight: 400;\n}\n\n.fc-scrollgrid-section-header .fc-scroller-harness,\n.fc-scrollgrid-section-header .fc-scroller {\n    overflow: visible !important;\n}\n\n.fc-scrollgrid-section-header .fc-col-header {\n    background: #F9F8F6;\n    margin: -10px 0 10px 0 !important;\n}\n\n.fc-scrollgrid-section-header .fc-col-header-cell {\n    height: 46px;\n    vertical-align: middle;\n}\n\n.fc-scrollgrid-section-header .fc-col-header-cell-cushion {\n    color: inherit;\n    font-weight: normal;\n}\n\n.fc-daygrid-body .fc-daygrid-day-frame {\n    background-color: #F9F8F6;\n}\n\n.fc-daygrid-body tr:first-child .fc-daygrid-day-frame {\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n}\n\n.fc-daygrid-body tr:last-child .fc-daygrid-day-frame {\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n}\n\n.fc-daygrid-body .fc-daygrid-day-top {\n    flex-direction: row;\n    justify-content: center;\n    padding-top: 8px;\n    padding-bottom: 8px;\n}\n\n.fc.daygrid-body .fc-daygrid-day-top .fc-daygrid-day-number,\n.fc-daygrid-body .fc-daygrid-day-top .fc-daygrid-day-number {\n    font-size: inherit;\n    min-width: 27px;\n    text-align: center;\n    border-radius: 1000px;\n}\n\n.fc-daygrid-body .fc-day.fc-day-today {\n    background-color: transparent;\n}\n\n.fc-daygrid-body .fc-day.fc-day-today .fc-daygrid-day-number {\n    background-color: #E78774;\n    color: #fff;\n}\n\n.fc-daygrid-more-link {\n    font-size: 10px;\n    color: inherit;\n    opacity: 0.4;\n    text-transform: lowercase;\n    padding: 4px 0;\n    display: inline-block;\n}\n\n/* salary events */\n\n.salary-calendar-event {\n    background: #7ce1b9 !important;\n    /*border: 1px solid #4fbf93 !important;*/\n    border:none;\n    border-radius: 8px !important;\n    margin-top: 4px !important;\n    padding: 0 !important;\n}\n\n.salary-calendar-event .fc-event-main {\n    padding: 0 !important;\n}\n\n.salary-calendar-event__inner {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    min-height: 28px;\n    padding: 4px 8px;\n    box-sizing: border-box;\n    font-size: 12px;\n    line-height: 1.2;\n    color: #fff;\n}\n\n.salary-calendar-event__title {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.salary-calendar-event__amount {\n    flex-shrink: 0;\n    white-space: nowrap;\n    color: #fff;\n}\n\n@media (max-width: 991px) {\n    .employee-salary__topbar-right {\n        text-align: left;\n    }\n\n    .employee-salary__topbar-right .btn {\n        margin-left: 0;\n        margin-right: 8px;\n        margin-bottom: 8px;\n    }\n\n    .salary-popup-modal .modal-dialog {\n        width: auto;\n        margin: 15px;\n    }\n}\n\n@media (max-width: 767px) {\n    .employee-salary__pager-label,\n    .salary-popup__date-label {\n        min-width: 180px;\n    }\n\n    .salary-popup__title {\n        font-size: 18px;\n    }\n\n    .salary-popup__header {\n        padding: 0 20px 10px;\n    }\n\n    .salary-popup__body {\n        padding: 10px 20px 20px;\n    }\n\n    .salary-popup__row {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 8px;\n    }\n\n    .salary-popup__row-label {\n        width: auto;\n        min-width: 0;\n    }\n\n    .salary-popup__footer {\n        padding: 0 20px 20px;\n        text-align: left;\n    }\n\n    .salary-popup__btn {\n        min-width: 0;\n        width: 100%;\n        margin: 0 0 10px 0;\n    }\n\n    .salary-popup__btn + .salary-popup__btn {\n        margin-left: 0;\n    }\n\n    .fc-floating-btn {\n        position: static;\n        margin-top: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
